import { Button } from '@krp/ui-kit'

import { OneCQueryState } from '../../../shared/ui/OneCQueryState'
import type { ReceiptsActions, ReceiptsVm } from '../model/viewModels'
import '../../../shared/ui/onec.css'
import '../../pricing/ui/onec-ui.css'
import './supplies.css'

/** Приходные накладные в 1С этой базы — только чтение (B3b, `Supplies_OneCReceipts`). */
export function ReceiptsScreen({ vm, actions }: { vm: ReceiptsVm; actions: ReceiptsActions }) {
  return (
    <section className="onec-screen" aria-label="Приходные в 1С">
      <div className="onec-toolbar">
        <h2>Приходные в 1С</h2>
        <Button variant="ghost" onClick={actions.reload}>
          Обновить
        </Button>
        <Button variant="ghost" onClick={actions.close}>
          Закрыть
        </Button>
      </div>
      <OneCQueryState query={vm.query} emptyText="Приходных нет" onRetry={actions.reload} />
      {vm.rows.length > 0 && (
        <div className="onec-scroll">
          <table className="onec-table">
            <thead>
              <tr>
                <th>Номер</th>
                <th>Дата в 1С</th>
                <th>Поставщик</th>
                <th>Склад</th>
                <th data-numeric="true">Строк</th>
                <th data-numeric="true">Сумма</th>
                <th>Проведена</th>
              </tr>
            </thead>
            <tbody>
              {vm.rows.map((row) => (
                <tr key={row.refKey}>
                  <td>{row.number ?? '—'}</td>
                  <td>{row.dateText}</td>
                  <td>{row.supplierName}</td>
                  <td>{row.warehouseName}</td>
                  <td data-numeric="true">{row.linesCount}</td>
                  <td data-numeric="true">{row.amount}</td>
                  <td>{row.posted ? '✓ да' : '✗ нет'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {vm.canLoadMore && (
        <Button variant="secondary" onClick={actions.loadMore}>
          Показать ещё
        </Button>
      )}
    </section>
  )
}
